// src/components/popups/DateRangeDrawer.js
import React, { useEffect, useMemo } from 'react';
import './DateRangeDrawer.css';

const BASE_OPTIONS = [
  { value: 'today', label: 'Today' },
  { value: '7d', label: 'Last 7 days' },
  { value: '30d', label: 'Last 30 days' },
  { value: '90d', label: 'Last 90 days' },
  { value: 'all', label: 'All time' },
];

export default function DateRangeDrawer({
  open,
  value,
  onClose,
  onChange,
  title = 'Date ranges',

  // ✅ new knobs (keep backwards compatible defaults)
  includeToday = true,
  include90d = false,
}) {
  useEffect(() => {
    if (!open) return;

    const onKeyDown = (e) => {
      if (e.key === 'Escape') onClose?.();
    };

    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [open, onClose]);

  const OPTIONS = useMemo(() => {
    return BASE_OPTIONS.filter((o) => {
      if (o.value === 'today') return includeToday;
      if (o.value === '90d') return include90d;
      return true;
    });
  }, [includeToday, include90d]);

  if (!open) return null;

  const handleSelect = (v) => {
    if (v !== value) onChange?.(v);
    onClose?.();
  };

  return (
    <>
      <div className="drd-backdrop" onClick={onClose} />

      <div className="drd-sheet" role="dialog" aria-modal="true" aria-label={title}>
        <div className="drd-handle" />

        <div className="drd-header">
          <div className="drd-title">{title}</div>
          <button type="button" className="drd-close" onClick={onClose} aria-label="Close">
            ✕
          </button>
        </div>

        <div className="drd-list">
          {OPTIONS.map((opt) => {
            const active = opt.value === value;
            return (
              <button
                key={opt.value}
                type="button"
                className={`drd-item ${active ? 'active' : ''}`}
                onClick={() => handleSelect(opt.value)}
              >
                <span className="drd-item-label">{opt.label}</span>
                <span className={`drd-radio ${active ? 'on' : ''}`} />
              </button>
            );
          })}
        </div>
      </div>
    </>
  );
}

// ✅ helper (now can be used for both screens)
export function labelForRange(r) {
  const hit = BASE_OPTIONS.find((o) => o.value === r);
  return hit?.label || 'Last 7 days';
}
